module.exports = __webpack_public_path__ + "static/media/fondo2.14e57d27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fondo2.png
// module id = 781
// module chunks = 0